import { useMutation } from "@apollo/client";
import React from "react";
import { FaTrashAlt } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { DELETE_ONE_FIRMWARE } from "../../../apollo/mutations";
import { ReactComponent as DeleteIcon } from "../../../images/ic-delete.svg";
import { DELETE_BUTTON, Loading } from "../../UI";

export const DeleteFirmware = ({ firmwareId, text }) => {
  // local set

  let history = useHistory();

  const [deleteFirmware, { loading }] = useMutation(DELETE_ONE_FIRMWARE, {
    onCompleted(data) {
      history.push(`/firmwares`);
    },
  });

  const handleDelete = () => {
    deleteFirmware({
      variables: {
        where: { id: firmwareId },
      },
    });
  };

  if (loading) return <Loading />;

  // render

  if (!text) {
    return <DeleteIcon onClick={handleDelete} />;
  }
  return (
    <DELETE_BUTTON onClick={() => handleDelete()}>
      <FaTrashAlt color="#eb506e" size={11} />
      <p>{text}</p>
    </DELETE_BUTTON>
  );
};
